import React from "react";

import { getCurrentProjectData } from "fond/project";
import LayerPanel from "fond/project/panels/InputPanel/LayerPanel";
import { deleteLayerFeatures, hasLayer } from "fond/project/redux";
import { LayerIds } from "fond/types";
import { useAppDispatch, useAppSelector } from "fond/utils/hooks";

/**
 * Entry panel for planner extended blockers, offering draw, upload and delete actions.
 */
const BlockersPanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const projectData = useAppSelector((state) => getCurrentProjectData(state.project));

  const handleDelete = () => dispatch(deleteLayerFeatures([LayerIds.blocker], LayerIds.blocker));

  return (
    <LayerPanel
      title="Blockers"
      layerKey="extended-design-blockers"
      actions={["draw", "upload", "delete"]}
      drawTitle="Edit blockers"
      drawSubtitle="Edit or draw blockers on the map"
      canDelete={hasLayer(projectData, LayerIds.blocker)}
      onDelete={handleDelete}
    />
  );
};

export default BlockersPanel;
